export default __webpack_public_path__ + "static/media/courts-logo-gray-400.f3a21cd2.svg";